import { useEffect } from "react";
import { Toaster as Sonner, toast } from "sonner";
import { CheckCircle2, XCircle, AlertTriangle, Info, Loader2 } from "lucide-react";

const Toaster = ({ ...props }) => {
  // Click anywhere on a toast to dismiss it (in addition to the close button / timeout).
  // We trigger the toast's own close button so the exit animation runs and only that
  // toast is dismissed.
  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest("[data-sonner-toast]");
      if (!el) return;
      if (e.target.closest("[data-close-button],[data-button],[data-action],a,button")) return;
      const closeBtn = el.querySelector("[data-close-button]");
      if (closeBtn) closeBtn.click();
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <Sonner
      theme="dark"
      className="toaster group"
      gap={10}
      icons={{
        success: <CheckCircle2 className="h-4 w-4" strokeWidth={2.25} />,
        error: <XCircle className="h-4 w-4" strokeWidth={2.25} />,
        warning: <AlertTriangle className="h-4 w-4" strokeWidth={2.25} />,
        info: <Info className="h-4 w-4" strokeWidth={2.25} />,
        loading: <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2.25} />,
      }}
      toastOptions={{
        classNames: {
          toast: "affilix-toast group cursor-pointer",
          title: "text-[13px] font-medium leading-tight",
          description: "text-xs text-muted-foreground",
          actionButton: "group-[.toast]:bg-white group-[.toast]:text-black",
          cancelButton: "group-[.toast]:bg-white/10 group-[.toast]:text-muted-foreground",
          closeButton: "affilix-toast-close",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
